import { createResourceStore } from "@/lib/resource";
import type { Shop } from "./Shop";
import type { Location } from "./Location";

export interface Business {
  id: string;
  name: string;
  ownerid: string;
  type: string;
  address: any;
  number_of_employees: number;
  tax_id_number: string;
  shop_logo: string | null;
  taxation_documents: string | null;
  national_id_card: any;
  created_at: string;
  updated_at: string;
  shops: Shop[];
  location: Location;
  // Settings
  profile_settings: string | null;
  notification_settings: string | null;
  security_settings: string | null;
  unit_settings: string | null;
}

export const useBusiness = createResourceStore<Business>("businesses");
